import { render, staticRenderFns } from "./ProfitAndLoss.vue?vue&type=template&id=2753a656&"
import script from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndLoss.vue?vue&type=style&index=0&id=2753a656&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports